import { render, staticRenderFns } from "./MagdeburgViz.vue?vue&type=template&id=3f9f5682&scoped=true"
import script from "./MagdeburgViz.vue?vue&type=script&lang=js"
export * from "./MagdeburgViz.vue?vue&type=script&lang=js"
import style0 from "./MagdeburgViz.vue?vue&type=style&index=0&id=3f9f5682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f5682",
  null
  
)

export default component.exports